export default {
  props: {
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    color: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    computedWidth () {
      return this.width ? this.width : ((this.height * this.DEFAULT_WIDTH) / this.DEFAULT_HEIGHT)
    },
    computedHeight () {
      return this.height ? this.height : ((this.width * this.DEFAULT_HEIGHT) / this.DEFAULT_WIDTH)
    },
  },
}
